<template>
  <div
    class="combat_lineup_container none"
    :class="[modeType, maxHeightClassName]"
  >
    <div class="combat_lineup_header">
      <template v-if="tableData && tableData.length > 0">
        <span
          class="half_table_group"
          v-for="group in tableData"
          :key="group.type"
        >
          <span class="table_title" :class="group.type">
            <template v-if="group.type === 'home'">
              <span
                class="teamName"
                v-text="group.team_name"
                @click="goDetail('CSMeetDelegationDetailIndex', group)"
              ></span>
              <span class="teamLogo">
                <img :src="group.team_logo" />
              </span>
            </template>
            <template v-if="group.type === 'away'">
              <span class="teamLogo">
                <img :src="group.team_logo" />
              </span>
              <span
                class="teamName"
                v-text="group.team_name"
                @click="goDetail('CSMeetDelegationDetailIndex', group)"
              ></span>
            </template>
          </span>
        </span>
      </template>
    </div>
    <div class="combat_lineup">
      <template v-if="tableData && tableData.length > 0">
        <span
          class="half_table_group"
          v-for="group in tableData"
          :key="group.type"
        >
          <span class="table_title" :class="group.type">
            <template v-if="group.type === 'home'">
              <span
                class="teamName"
                v-text="group.team_name"
                @click="goDetail('CSMeetDelegationDetailIndex', group)"
              ></span>
              <span class="teamLogo">
                <img :src="group.team_logo" />
              </span>
            </template>
            <template v-if="group.type === 'away'">
              <span class="teamLogo">
                <img :src="group.team_logo" />
              </span>
              <span
                class="teamName"
                v-text="group.team_name"
                @click="goDetail('CSMeetDelegationDetailIndex', group)"
              ></span>
            </template>
          </span>
          <span
            class="table_main"
            :class="[group.type, isMaxType === group.type ? 'isMax' : '']"
          >
            <span class="customTable">
              <template v-if="currModeName === 'column1-playerInfor'">
                <span
                  class="customTable_row"
                  :class="currModeName"
                  v-for="rowItem in group.list"
                  :key="rowItem.player_id"
                >
                  <span
                    class="playerName-playerLogo-playerGender-teamLogo-teamName"
                  >
                    <span
                      class="playerLogo"
                      :class="[
                        rowItem['player_logo'] ? 'isLogo' : '',
                        rowItem['player_gender'],
                      ]"
                    >
                      <img
                        v-if="rowItem['player_logo']"
                        :src="rowItem['player_logo']"
                      />
                    </span>
                    <span class="playerOther">
                      <span class="teamInfor">
                        <span class="teamLogo">
                          <img :src="rowItem['team_logo']" />
                        </span>
                        <span
                          class="teamName"
                          v-text="_valPerFormatHandler(rowItem['team_name'])"
                        ></span>
                      </span>
                      <span
                        class="playerName"
                        v-text="_valPerFormatHandler(rowItem['player_name'])"
                        @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                      ></span>
                    </span>
                  </span>
                </span>
              </template>
              <template v-if="currModeName === 'column2-playerInfor-birthDate'">
                <span
                  class="customTable_row"
                  :class="currModeName"
                  v-for="rowItem in group.list"
                  :key="rowItem.player_id"
                >
                  <span
                    class="playerName-playerLogo-playerGender-teamLogo-teamName"
                  >
                    <span
                      class="playerLogo"
                      :class="[
                        rowItem['player_logo'] ? 'isLogo' : '',
                        rowItem['player_gender'],
                      ]"
                    >
                      <img
                        v-if="rowItem['player_logo']"
                        :src="rowItem['player_logo']"
                      />
                    </span>
                    <span class="playerOther">
                      <span class="teamInfor">
                        <span class="teamLogo">
                          <img :src="rowItem['team_logo']" />
                        </span>
                        <span
                          class="teamName"
                          v-text="_valPerFormatHandler(rowItem['team_name'])"
                        ></span>
                      </span>
                      <span
                        class="playerName"
                        v-text="_valPerFormatHandler(rowItem['player_name'])"
                        @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                      ></span>
                    </span>
                  </span>
                  <span
                    class="player_birthDate"
                    v-text="_valPerFormatHandler(rowItem['birth_date'])"
                  ></span>
                </span>
              </template>

              <template
                v-else-if="currModeName === 'column2-playerInfor-playerNO'"
              >
                <span
                  class="customTable_row"
                  :class="currModeName"
                  v-for="rowItem in group.list"
                  :key="rowItem.player_id"
                >
                  <span
                    class="playerName-playerLogo-playerGender-teamLogo-teamName"
                  >
                    <span
                      class="playerLogo"
                      :class="[
                        rowItem['player_logo'] ? 'isLogo' : '',
                        rowItem['player_gender'],
                      ]"
                    >
                      <img
                        v-if="rowItem['player_logo']"
                        :src="rowItem['player_logo']"
                      />
                    </span>
                    <span class="playerOther">
                      <span class="teamInfor">
                        <span class="teamLogo">
                          <img :src="rowItem['team_logo']" />
                        </span>
                        <span
                          class="teamName"
                          v-text="_valPerFormatHandler(rowItem['team_name'])"
                        ></span>
                      </span>
                      <span
                        class="playerName"
                        v-text="_valPerFormatHandler(rowItem['player_name'])"
                        @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                      ></span>
                    </span>
                  </span>
                  <span
                    class="player_number"
                    v-text="_valPerFormatHandler(rowItem.bib_number)"
                  ></span>
                </span>
              </template>
              <template v-else-if="currModeName === 'column3-playerInfor'">
                <span
                  class="customTable_row"
                  :class="currModeName"
                  v-for="rowItem in group.list"
                  :key="rowItem.player_id"
                >
                  <span
                    class="playerName-playerLogo-playerGender-teamLogo-teamName"
                  >
                    <span
                      class="playerLogo"
                      :class="[
                        rowItem['player_logo'] ? 'isLogo' : '',
                        rowItem['player_gender'],
                      ]"
                    >
                      <img
                        v-if="rowItem['player_logo']"
                        :src="rowItem['player_logo']"
                      />
                    </span>
                    <span class="playerOther">
                      <span class="teamInfor">
                        <span class="teamLogo">
                          <img :src="rowItem['team_logo']" />
                        </span>
                        <span
                          class="teamName"
                          v-text="_valPerFormatHandler(rowItem['team_name'])"
                        ></span>
                      </span>
                      <span
                        class="playerName"
                        v-text="_valPerFormatHandler(rowItem['player_name'])"
                        @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                      ></span>
                    </span>
                  </span>
                  <span
                    class="player_number"
                    v-text="_valPerFormatHandler(rowItem.bib_number)"
                  ></span>
                  <span
                    v-if="rowItem.is_starter"
                    class="start_icon"
                    v-text="'首'"
                  ></span>
                </span>
              </template>
              <template
                v-else-if="currModeName === 'column1-playerInfor-color'"
              >
                <span
                  class="customTable_row"
                  :class="currModeName"
                  v-for="rowItem in group.list"
                  :key="rowItem.player_id"
                >
                  <span
                    class="playerName-playerLogo-playerGender-teamLogo-teamName"
                  >
                    <span
                      class="playerLogo"
                      :class="[
                        rowItem['player_logo'] ? 'isLogo' : '',
                        rowItem['player_gender'],
                      ]"
                    >
                      <img
                        v-if="rowItem['player_logo']"
                        :src="rowItem['player_logo']"
                      />
                    </span>
                    <span class="playerOther">
                      <span class="teamInfor">
                        <span class="teamLogo">
                          <img :src="rowItem['team_logo']" />
                        </span>
                        <span
                          class="teamName"
                          v-text="_valPerFormatHandler(rowItem['team_name'])"
                        ></span>
                      </span>
                      <span
                        class="playerName"
                        v-text="_valPerFormatHandler(rowItem['player_name'])"
                        @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                      ></span>
                    </span>
                  </span>
                  <span
                    class="color"
                    :style="{
                      backgroundColor: `${rowItem['clothing_color']}`,
                      borderColor: `${
                        ['WHITE', 'white'].includes(rowItem['clothing_color'])
                          ? 'GREY'
                          : rowItem['clothing_color']
                      }`,
                    }"
                  ></span>
                </span>
              </template>

              <template v-else-if="currModeName === 'column2-playerInfor-num'">
                <span
                  class="customTable_row"
                  :class="currModeName"
                  v-for="rowItem in group.list"
                  :key="rowItem.player_id"
                >
                  <span
                    class="playerName-playerLogo-playerGender-teamLogo-teamName"
                  >
                    <span
                      class="playerLogo"
                      :class="[
                        rowItem['player_logo'] ? 'isLogo' : '',
                        rowItem['player_gender'],
                      ]"
                    >
                      <img
                        v-if="rowItem['player_logo']"
                        :src="rowItem['player_logo']"
                      />
                    </span>
                    <span class="playerOther">
                      <span class="teamInfor">
                        <span class="teamLogo">
                          <img :src="rowItem['team_logo']" />
                        </span>
                        <span
                          class="teamName"
                          v-text="_valPerFormatHandler(rowItem['team_name'])"
                        ></span>
                      </span>
                      <span
                        class="playerName"
                        v-text="_valPerFormatHandler(rowItem['player_name'])"
                        @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                      ></span>
                    </span>
                  </span>
                  <span
                    class="player_num"
                    v-text="_valPerFormatHandler(rowItem['sequence_number'])"
                  ></span>
                </span>
              </template>
              <template
                v-else-if="currModeName === 'column3-playerInfor-position'"
              >
                <span
                  class="customTable_row"
                  :class="currModeName"
                  v-for="rowItem in group.list"
                  :key="rowItem.player_id"
                >
                  <span
                    class="playerName-playerLogo-playerGender-teamLogo-teamName"
                  >
                    <span
                      class="playerLogo"
                      :class="[
                        rowItem['player_logo'] ? 'isLogo' : '',
                        rowItem['player_gender'],
                      ]"
                    >
                      <img
                        v-if="rowItem['player_logo']"
                        :src="rowItem['player_logo']"
                      />
                    </span>
                    <span class="playerOther">
                      <span class="teamInfor">
                        <span class="teamLogo">
                          <img :src="rowItem['team_logo']" />
                        </span>
                        <span
                          class="teamName"
                          v-text="_valPerFormatHandler(rowItem['team_name'])"
                        ></span>
                      </span>
                      <span
                        class="playerName"
                        v-text="_valPerFormatHandler(rowItem['player_name'])"
                        @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                      ></span>
                    </span>
                  </span>
                  <span
                    class="player_number"
                    :class="rowItem.is_coach ? 'hide' : ''"
                    v-text="_valPerFormatHandler(rowItem.bib_number)"
                  ></span>
                  <span
                    class="player_state"
                    v-text="
                      rowItem.is_coach
                        ? '教练'
                        : rowItem.position_name
                        ? rowItem.position_name
                        : ''
                    "
                  ></span>
                </span>
              </template>
              <template
                v-else-if="
                  [
                    'column4-playerInfor-position-isStart',
                    'column3-playerInfor-position-isStart',
                  ].includes(currModeName)
                "
              >
                <span
                  class="customTable_row"
                  :class="currModeName"
                  v-for="rowItem in group.list"
                  :key="rowItem.player_id"
                >
                  <span
                    class="playerName-playerLogo-playerGender-teamLogo-teamName"
                  >
                    <span
                      class="playerLogo"
                      :class="[
                        rowItem['player_logo'] ? 'isLogo' : '',
                        rowItem['player_gender'],
                      ]"
                    >
                      <img
                        v-if="rowItem['player_logo']"
                        :src="rowItem['player_logo']"
                      />
                    </span>
                    <span class="playerOther">
                      <span class="teamInfor">
                        <span class="teamLogo">
                          <img :src="rowItem['team_logo']" />
                        </span>
                        <span
                          class="teamName"
                          v-text="_valPerFormatHandler(rowItem['team_name'])"
                        ></span>
                      </span>
                      <span
                        class="playerName"
                        v-text="_valPerFormatHandler(rowItem['player_name'])"
                        @click="goDetail('CSMeetPlayerDetailIndex', rowItem)"
                      ></span>
                    </span>
                  </span>
                  <span
                    v-if="
                      currModeName === 'column4-playerInfor-position-isStart'
                    "
                    class="player_number"
                    :class="rowItem.is_coach ? 'hide' : ''"
                    v-text="_valPerFormatHandler(rowItem.bib_number)"
                  ></span>
                  <span
                    class="player_state"
                    v-text="
                      rowItem.is_coach
                        ? '教练'
                        : rowItem.position_name
                        ? rowItem.position_name
                        : ''
                    "
                  ></span>
                  <span
                    v-if="rowItem.is_starter"
                    class="start_icon"
                    v-text="'首'"
                  ></span>
                </span>
              </template>
            </span>
          </span>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
// 适用： 对抗类 阵容 展示代表团双方+各自队员
// import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'combat_lineup_container',
  props: {
    sportsId: {
      type: String,
      default: '',
    },
    modeType: {
      type: String,
      default: 'double', // ['single', 'double']
    },
    datas: {
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          home: [],
          away: [],
        },
        statisticsModels: [],
      }),
    },
    // testDatas: {
    //   type: Object,
    //   default: () => ({
    //     objectInfo: [
    //       {
    //         teamName: '阿根廷',
    //         teamId: 1020,
    //         teamLogo: 'https://images.mixtmt.com/hyper/football/team/1020.png',
    //         teamScore: 7,
    //         playerName: '',
    //         personNameEn: '',
    //         playerId: 0,
    //         profilePicture: 'players.png',
    //         position: '',
    //         shirtNumber: 0,
    //         positionName: null,
    //         age: null,
    //         height: null,
    //         weight: null,
    //       },
    //       {
    //         teamName: '法国',
    //         teamId: 1008,
    //         teamLogo: 'https://images.mixtmt.com/hyper/football/team/1008.png',
    //         teamScore: 5,
    //         playerName: '',
    //         personNameEn: '',
    //         playerId: 0,
    //         profilePicture: 'players.png',
    //         position: '',
    //         shirtNumber: 0,
    //         positionName: null,
    //         age: null,
    //         height: null,
    //         weight: null,
    //       },
    //     ],
    //     templateId: 1038,
    //     statisticsModels: [
    //       {
    //         id: null,
    //         name: null,
    //         tableName: null,
    //         columnName: null,
    //         type: null,
    //         sort: null,
    //         statisticalEn: null,
    //         suffix: '',
    //         isAuto: null,
    //       },
    //     ],
    //     analysisItemId: '4a2f34d538a7406c91902bae64cf1752',
    //     competitionId: 109,
    //     seasonId: 1039,
    //     matchId: null,
    //     graphicsId: 26,
    //     title: '球员评分',
    //     data: {
    //       dataList: [
    //         [
    //           {
    //             playerId: 100672,
    //             playerName: '埃米利亚诺·马丁内斯',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100672.png',
    //             shirtNumber: 23,
    //             x: '50',
    //             y: '670',
    //             score: 3.1,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102356,
    //             playerName: '胡利安·阿尔瓦雷斯',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102356.png',
    //             shirtNumber: 9,
    //             x: '801',
    //             y: '670',
    //             score: 4.7,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100704,
    //             playerName: '利昂内尔·梅西',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100704.png',
    //             shirtNumber: 10,
    //             x: '802',
    //             y: '335',
    //             score: 8.1,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102629,
    //             playerName: '恩索·费尔南德斯',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102629.png',
    //             shirtNumber: 24,
    //             x: '540',
    //             y: '670',
    //             score: 3.7,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102630,
    //             playerName: '罗德里戈·德保罗',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102630.png',
    //             shirtNumber: 7,
    //             x: '540',
    //             y: '335',
    //             score: 6.4,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100689,
    //             playerName: '安赫尔·迪马里亚',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100689.png',
    //             shirtNumber: 11,
    //             x: '800',
    //             y: '1005',
    //             score: 8.7,
    //             maxScore: 8.7,
    //             isMax: 1,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102102,
    //             playerName: '亚历克西斯·麦卡利斯特',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102102.png',
    //             shirtNumber: 20,
    //             x: '540',
    //             y: '1005',
    //             score: 7.9,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102638,
    //             playerName: '纳韦尔·莫利纳',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102638.png',
    //             shirtNumber: 26,
    //             x: '300',
    //             y: '268',
    //             score: 5.7,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102489,
    //             playerName: '克里斯蒂安·罗梅罗',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102489.png',
    //             shirtNumber: 13,
    //             x: '300',
    //             y: '536',
    //             score: 6.8,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100673,
    //             playerName: '尼古拉斯·塔利亚菲科',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100673.png',
    //             shirtNumber: 3,
    //             x: '300',
    //             y: '1072',
    //             score: 6.9,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100720,
    //             playerName: '尼古拉斯·奥塔门迪',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100720.png',
    //             shirtNumber: 19,
    //             x: '300',
    //             y: '804',
    //             score: 3.1,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100716,
    //             playerName: '马科斯·阿库尼亚',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100716.png',
    //             shirtNumber: 8,
    //             x: null,
    //             y: null,
    //             score: 4.9,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102628,
    //             playerName: '贡萨洛·蒙铁尔',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102628.png',
    //             shirtNumber: 4,
    //             x: null,
    //             y: null,
    //             score: 2.5,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100691,
    //             playerName: '劳塔罗·马丁内斯',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100691.png',
    //             shirtNumber: 22,
    //             x: null,
    //             y: null,
    //             score: 4,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100698,
    //             playerName: '莱安德罗·帕雷德斯',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100698.png',
    //             shirtNumber: 5,
    //             x: null,
    //             y: null,
    //             score: 6.4,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100692,
    //             playerName: '赫尔曼·佩泽拉',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100692.png',
    //             shirtNumber: 6,
    //             x: null,
    //             y: null,
    //             score: 6,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100696,
    //             playerName: '保罗·迪巴拉',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100696.png',
    //             shirtNumber: 21,
    //             x: null,
    //             y: null,
    //             score: 6,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: -1,
    //             playerName: null,
    //             playerLogo: '',
    //             shirtNumber: null,
    //             x: null,
    //             y: null,
    //             score: 5.6,
    //             maxScore: 8.7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //         ],
    //         [
    //           {
    //             playerId: 100108,
    //             playerName: '雨果·洛里',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100108.png',
    //             shirtNumber: 1,
    //             x: 1950,
    //             y: '670',
    //             score: 6,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100090,
    //             playerName: '奥利维耶·吉鲁',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100090.png',
    //             shirtNumber: 9,
    //             x: 1199,
    //             y: '670',
    //             score: 5.5,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100100,
    //             playerName: '奥斯曼·登贝莱',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100100.png',
    //             shirtNumber: 11,
    //             x: 1198,
    //             y: '335',
    //             score: 3.2,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102794,
    //             playerName: '奥雷利安·楚阿梅尼',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102794.png',
    //             shirtNumber: 8,
    //             x: 1460,
    //             y: '670',
    //             score: 3.7,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100093,
    //             playerName: '安托万·格里茨曼',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100093.png',
    //             shirtNumber: 7,
    //             x: 1460,
    //             y: '335',
    //             score: 5.2,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100091,
    //             playerName: '基利安·姆巴佩',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100091.png',
    //             shirtNumber: 10,
    //             x: 1200,
    //             y: '1005',
    //             score: 7,
    //             maxScore: 7,
    //             isMax: 1,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100086,
    //             playerName: '阿德里安·拉比奥',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100086.png',
    //             shirtNumber: 14,
    //             x: 1460,
    //             y: '1005',
    //             score: 5.5,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100101,
    //             playerName: '朱尔·昆代',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100101.png',
    //             shirtNumber: 5,
    //             x: 1700,
    //             y: '268',
    //             score: 4.2,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 116257,
    //             playerName: '特奥·埃尔南德斯',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/116257.png',
    //             shirtNumber: 22,
    //             x: 1700,
    //             y: '1072',
    //             score: 6,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102801,
    //             playerName: '达约·乌帕梅卡诺',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102801.png',
    //             shirtNumber: 18,
    //             x: 1700,
    //             y: '804',
    //             score: 5.4,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100087,
    //             playerName: '拉斐尔·瓦拉内',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100087.png',
    //             shirtNumber: 4,
    //             x: 1700,
    //             y: '536',
    //             score: 5.7,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100092,
    //             playerName: '马库斯·图拉姆',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100092.png',
    //             shirtNumber: 26,
    //             x: null,
    //             y: null,
    //             score: 5.5,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102800,
    //             playerName: '兰德尔·科洛',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102800.png',
    //             shirtNumber: 12,
    //             x: null,
    //             y: null,
    //             score: 3.4,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102796,
    //             playerName: '优素福·福法纳',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102796.png',
    //             shirtNumber: 13,
    //             x: null,
    //             y: null,
    //             score: 6.1,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 100085,
    //             playerName: '金斯利·科芒',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/100085.png',
    //             shirtNumber: 20,
    //             x: null,
    //             y: null,
    //             score: 5.5,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102798,
    //             playerName: '爱德华多·卡马温加',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102798.png',
    //             shirtNumber: 25,
    //             x: null,
    //             y: null,
    //             score: 6.9,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 102306,
    //             playerName: '易卜拉希马·科纳特',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/102306.png',
    //             shirtNumber: 24,
    //             x: null,
    //             y: null,
    //             score: 6.3,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: 116256,
    //             playerName: '阿克塞尔·迪萨西',
    //             playerLogo:
    //               'https://images.mixtmt.com/hyper/football/world-cup/2022/person/116256.png',
    //             shirtNumber: 3,
    //             x: null,
    //             y: null,
    //             score: 0,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //           {
    //             playerId: -1,
    //             playerName: null,
    //             playerLogo: '',
    //             shirtNumber: null,
    //             x: null,
    //             y: null,
    //             score: 5.4,
    //             maxScore: 7,
    //             isMax: 0,
    //             teamLogo: '',
    //           },
    //         ],
    //       ],
    //     },
    //     limitCount: null,
    //     json: null,
    //     seasonOrMatch: true,
    //     haveCdvPackage: false,
    //     needPicture: false,
    //     needMax: false,
    //   }),
    // },
  },
  // mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('combat_lineup 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      maxHeightClassName: '',
      dataKeys: [],
      tableData: null,
      isMaxType: '',
      currModeName: '',
      renderModeList: [
        {
          modeName: 'column1-playerInfor',
          sportsIdArr: ['ARC'],
        },
        {
          modeName: 'column2-playerInfor-birthDate',
          sportsIdArr: ['TTE', 'BDM', 'TEN'],
        },
        {
          modeName: 'column2-playerInfor-playerNO',
          sportsIdArr: ['WPO'],
        },
        {
          modeName: 'column3-playerInfor',
          sportsIdArr: ['BKB', 'VVO'],
          maxHeightClassName: 'height27s5vw mtb1388',
          dataKeys: [
            [
              'teamId',
              'teamName',
              'teamLogo',
              'playerId',
              'playerName',
              'playerLogo',
              'shirtNumber',
              'isCoach',
              'positionName',
            ],
            [
              'team_id',
              'team_name',
              'team_logo',
              'player_id',
              'player_name',
              'player_logo',
              'bib_number',
              'is_coach',
              'position_name',
            ],
          ],
        },
        {
          modeName: 'column1-playerInfor-color',
          sportsIdArr: ['JUD', 'TKW'],
        },
        {
          modeName: 'column2-playerInfor-num',
          sportsIdArr: ['FEN'],
        },
        // {
        //   modeName: 'column3-playerInfor-position',
        //   sportsIdArr: ['FBL', 'IHO'],
        //   maxHeightClassName: 'height27s5vw mtb1388',
        //   dataKeys: [
        //     [
        //       'teamId',
        //       'teamName',
        //       'teamLogo',
        //       'playerId',
        //       'playerName',
        //       'playerLogo',
        //       'shirtNumber',
        //       'isCoach',
        //       'positionName',
        //     ],
        //     [
        //       'team_id',
        //       'team_name',
        //       'team_logo',
        //       'player_id',
        //       'player_name',
        //       'player_logo',
        //       'bib_number',
        //       'is_coach',
        //       'position_name',
        //     ],
        //   ],
        // },
        {
          modeName: 'column4-playerInfor-position-isStart',
          sportsIdArr: ['FBL', 'IHO', 'FIBAWA'],
          maxHeightClassName: 'height27s5vw mtb1388',
          dataKeys: [
            [
              'teamId',
              'teamName',
              'teamLogo',
              'playerId',
              'playerName',
              'playerLogo',
              'shirtNumber',
              'isCoach',
              'positionName',
              'isStarter',
            ],
            [
              'team_id',
              'team_name',
              'team_logo',
              'player_id',
              'player_name',
              'player_logo',
              'bib_number',
              'is_coach',
              'position_name',
              'is_starter',
            ],
          ],
        },
        {
          modeName: 'column3-playerInfor-position-isStart', //与 column4-playerInfor-position-isStart 的区别不带球衣号
          sportsIdArr: ['CUR'],
        },
      ],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      console.debug('combat_lineup ', this.sportsId, this.datas)
      this.$nextTick(() => {
        if (this.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.sportsIdArr.includes(this.sportsId)) {
              this.currModeName = modeItem.modeName
              if (modeItem.dataKeys) {
                this.dataKeys = modeItem.dataKeys
              }
              if (this.modeType === 'double') {
                // 双方阵容需要增加 maxHeightClassName
                this.maxHeightClassName = modeItem.maxHeightClassName
                  ? modeItem.maxHeightClassName
                  : ''
              }
            }
          })
        }
        this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
        // this.computedModeData(JSON.parse(JSON.stringify(this.testDatas)))
      })
    },
    goDetail(routerName, item, id) {
      return
      console.debug(routerName, item)
      let query = {}
      if (routerName == 'CSMeetPlayerDetailIndex') {
        query.playerId = item ? item.player_id : id
      }
      if (routerName == 'CSMeetDelegationDetailIndex') {
        query.delegationId = item ? item.team_id : id
      }
      this.pageJump(this.$router, `${routerName}_${this.currCid}`, query)
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    notDataHandler() {
      this.tableData = []
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      const keyArr = ['home', 'away']
      if (data.data.dataList && !data.data[keyArr[0]]) {
        data.home = data.data.dataList[0] //单支球队 【足球】
      } else if (data.data) {
        // 双方球队【足球】
        data.home = data.data[keyArr[0]]
        data.away = data.data[keyArr[1]]
        // data.data.forEach((team, index) => {
        //   data[keyArr[index]] = [].concat(data[keyArr[index]], team)
        // })
      }
      const humpDataKeys = this.dataKeys[0]
      const unHumpDataKeys = this.dataKeys[1]
      let dataKeys = []
      let isHumpDataKeysFlag = false
      let tableData = []
      let isMaxType = ''
      let homeNum = 0,
        awayNum = 0
      console.debug('humpDataKeys:', data[keyArr[0]], this.dataKeys, data.home)
      if (data[keyArr[0]] && data[keyArr[0]].length > 0) {
        if (data[keyArr[0]][0][humpDataKeys[3]]) {
          isHumpDataKeysFlag = true
          dataKeys = humpDataKeys
        } else {
          isHumpDataKeysFlag = false
          dataKeys = unHumpDataKeys
        }
        console.debug(
          'isHumpDataKeysFlag:',
          isHumpDataKeysFlag,
          data[keyArr[0]][0],
          dataKeys
        )
        homeNum = data[keyArr[0]].length
        tableData.push({
          type: keyArr[0],
          list: isHumpDataKeysFlag
            ? data[keyArr[0]].map((item) => {
                humpDataKeys.forEach((key, keyIndex) => {
                  if (keyIndex > 2) {
                    item[unHumpDataKeys[keyIndex]] = item[key]
                  }
                })
                item.team_id = data.objectInfo[0][humpDataKeys[0]]
                item.team_name = data.objectInfo[0][humpDataKeys[1]]
                item.team_logo = data.objectInfo[0][humpDataKeys[2]]
                return item
              })
            : data[keyArr[0]],
          team_id: data.objectInfo[0][humpDataKeys[0]],
          team_name: data.objectInfo[0][humpDataKeys[1]],
          team_logo: data.objectInfo[0][humpDataKeys[2]],
        })
      } else {
        if (this.modeType === 'double') {
          tableData.push({
            type: keyArr[0],
            list: [],
            team_id: '',
            team_name: '',
            team_logo: '',
          })
        }
      }
      if (data[keyArr[1]] && data[keyArr[1]].length > 0) {
        awayNum = data[keyArr[1]].length
        if (data[keyArr[1]][0][humpDataKeys[3]]) {
          isHumpDataKeysFlag = true
          dataKeys = humpDataKeys
        } else {
          isHumpDataKeysFlag = false
          dataKeys = unHumpDataKeys
        }
        tableData.push({
          type: keyArr[1],
          list: isHumpDataKeysFlag
            ? data[keyArr[1]].map((item) => {
                humpDataKeys.forEach((key, keyIndex) => {
                  if (keyIndex > 2) {
                    item[unHumpDataKeys[keyIndex]] = item[key]
                  }
                })
                item.team_id = data.objectInfo[1][humpDataKeys[0]]
                item.team_name = data.objectInfo[1][humpDataKeys[1]]
                item.team_logo = data.objectInfo[1][humpDataKeys[2]]
                return item
              })
            : data[keyArr[1]],
          team_id: data.objectInfo[1][humpDataKeys[0]],
          team_name: data.objectInfo[1][humpDataKeys[1]],
          team_logo: data.objectInfo[1][humpDataKeys[2]],
        })
      } else {
        if (this.modeType === 'double') {
          tableData.push({
            type: keyArr[1],
            playerList: [],
            team_id: '',
            team_name: '',
            team_logo: '',
          })
        }
      }
      if (tableData.length > 0) {
        if (this.modeType === 'double') {
          if (homeNum >= awayNum) {
            isMaxType = 'home'
          } else {
            isMaxType = 'away'
          }
        } else {
          isMaxType = '' //单个时默认不需要竖线
        }
        this.isMaxType = isMaxType
        this.tableData = tableData
        console.debug('tableData:', tableData)
      } else {
        this.notDataHandler()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.combat_lineup_container {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  &.height27s5vw {
    max-height: 27.5vw;
    height: auto;
  }
  &.mtb1388 {
    margin: 1.388vw 0;
    .combat_lineup_header {
      top: 1.388vw;
    }
  }
  &.single {
    padding: 0.347vw 0;
    .combat_lineup_header {
      top: 0.347vw;
      left: 0;
      width: 100%;
    }
    .combat_lineup_header,
    .combat_lineup {
      justify-content: center;
    }
    .combat_lineup_header .half_table_group,
    .combat_lineup .half_table_group {
      width: 100%;
      padding: 0 2%;
    }
  }
  .combat_lineup_header {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
    .half_table_group {
      width: 50%;
      height: auto;
      /* background-color: var(--mixtmt_greyColor8); */
      .table_title {
        position: relative;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        color: var(--mixtmt_whiteColor);
        width: 100%;
        height: 2.5vw;
        background-color: var(--mixtmt_mainColor8);
        &.home {
          .teamName {
            padding-right: 0.694vw;
          }
        }
        &.away {
          .teamName {
            padding-left: 0.694vw;
          }
        }
        .teamLogo {
          width: 2.49vw;
          height: 1.66vw;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .teamName {
          font-size: 1.11vw;
          font-weight: bold;
        }
      }
    }
  }
  .combat_lineup {
    position: relative;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
    .half_table_group {
      width: 50%;
      height: auto;
      /* background-color: var(--mixtmt_greyColor8); */
      .table_title {
        position: relative;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        color: var(--mixtmt_whiteColor);
        width: 100%;
        height: 2.5vw;
        background-color: var(--mixtmt_mainColor8);
        &.home {
          .teamName {
            padding-right: 0.694vw;
          }
        }
        &.away {
          .teamName {
            padding-left: 0.694vw;
          }
        }
        .teamLogo {
          width: 2.49vw;
          height: 1.66vw;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .teamName {
          font-size: 1.11vw;
          font-weight: bold;
        }
      }
      .table_main {
        position: relative;
        width: 100%;
        height: auto;
        color: var(--mixtmt_greyColor3);
        &.home {
          &.isMax {
            &::before {
              content: '\20';
              position: absolute;
              top: 0;
              right: 0;
              z-index: 2;
              width: 1px;
              height: 100%;
              background-color: var(--mixtmt_greyColor7);
            }
          }
          .player_number {
            background-image: var(--mixtmt_homePlayerNo_bg);
          }
        }
        &.away {
          &.isMax {
            &::before {
              content: '\20';
              position: absolute;
              top: 0;
              left: 0;
              z-index: 2;
              width: 1px;
              height: 100%;
              background-color: var(--mixtmt_greyColor7);
            }
          }
          .player_number {
            background-image: var(--mixtmt_awayPlayerNo_bg);
          }
        }
        .customTable {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
        }

        .customTable_row {
          position: relative;
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          height: 5.55vw;
          padding: 0 0.694vw;
          border-bottom: 1px solid var(--mixtmt_greyColor7);
          &.column4-playerInfor-position-isStart {
            .playerName-playerLogo-playerGender-teamLogo-teamName {
              width: 20vw;
            }
          }
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            height: 4.16vw;
            width: 25vw;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            overflow: hidden;
            .playerLogo {
              position: relative;
              width: 4.16vw;
              height: 4.16vw;
              border-radius: 50%;
              background-size: 100% auto;
              background-position: left 35%;
              background-repeat: no-repeat;
              background-image: var(--mixtmt_default_playerLogo);
              &::before {
                position: absolute;
                content: '\20';
                bottom: 0;
                right: 0;
                z-index: 5;
                width: 1.11vw;
                height: 1.11vw;
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: center;
                /* background-image: var(--mixtmt_gender_male_icon); */
              }
              &::after {
                position: absolute;
                content: '\20';
                bottom: 0;
                right: 0;
                z-index: 2;
                width: 100%;
                height: 100%;
                border-radius: 50%;
                border: 1px solid var(--mixtmt_greyColor5);
              }
              &.F {
                &::before {
                  background-image: var(--mixtmt_gender_female_icon);
                }
              }
              &.M {
                &::before {
                  background-image: var(--mixtmt_gender_male_icon);
                }
              }
              &.isLogo {
                background-image: none;
              }
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 50%;
              }
            }
            .playerOther {
              width: calc(100% - 4.16vw);
              padding: 0 0.694vw;
              height: 4.16vw;
              display: flex;
              display: -webkit-flex;
              justify-content: space-between;
              align-items: flex-start;
              flex-direction: column;
              .teamInfor {
                width: 100%;
                height: 1.66vw;
                display: flex;
                display: -webkit-flex;
                justify-content: flex-start;
                align-items: center;
                .teamLogo {
                  width: 2.5vw;
                  height: 1.66vw;
                  overflow: hidden;
                  img {
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                }
                .teamName {
                  padding-left: 0.694vw;
                  font-size: 0.972vw;
                  color: var(--mixtmt_greyColor2);
                }
              }
              .playerName {
                width: auto;
                max-width: 100%;
                font-size: 1.11vw;
                height: 1.38vw;
                line-height: 1.38vw;
                color: var(--mixtmt_greyColor3);
                text-align: left;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .player_number {
            margin: 0 0.694vw;
            width: 3.47vw;
            height: 2.788vw;
            background-repeat: no-repeat;
            background-position: center;
            background-size: 100% 100%;
            color: var(--mixtmt_whiteColor);
            line-height: 2.788vw;
            font-size: 1.11vw;
            text-align: center;
            &.hide {
              background-image: none !important;
            }
          }
          .player_state {
            width: 6.94vw;
            color: var(--mixtmt_greyColor2);
            font-size: 1.11vw;
            text-align: center;
          }
          .player_birthDate {
            width: 9.72vw;
            color: var(--mixtmt_greyColor2);
            font-size: 1.11vw;
            text-align: center;
          }
          .player_num {
            width: 6.94vw;
            color: var(--mixtmt_greyColor2);
            font-size: 1.11vw;
            text-align: center;
          }
          .start_icon {
            position: absolute;
            right: 0.694vw;
            top: 50%;
            z-index: 0;
            width: 1.68vw;
            height: 1.68vw;
            border-radius: 50%;
            background-color: var(--mixtmt_successColor);
            transform: translateY(-50%);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            color: var(--mixtmt_whiteColor);
            font-size: 0.972vw;
          }
          &.column1-playerInfor {
            padding: 0 0.694vw 0 4.16vw;
            .playerName-playerLogo-playerGender-teamLogo-teamName {
              width: 100%;
            }
          }
          &.column2-playerInfor-birthDate {
            padding: 0 0 0 2.083vw;
            .playerName-playerLogo-playerGender-teamLogo-teamName {
              width: calc(100% - 9.72vw);
            }
          }

          &.column2-playerInfor-num {
            padding: 0 0 0 2.083vw;
            .playerName-playerLogo-playerGender-teamLogo-teamName {
              width: calc(100% - 6.94vw);
            }
          }

          &.column3-playerInfor {
            padding: 0 0 0 2.083vw;
            .playerName-playerLogo-playerGender-teamLogo-teamName {
              width: calc(100% - 3.47vw - 1.388vw - 6.94vw);
            }
          }
          &.column2-playerInfor-playerNO {
            .playerName-playerLogo-playerGender-teamLogo-teamName {
              width: calc(100% - 6.94vw - 1.388vw);
            }
          }
          &.column1-playerInfor-color {
            padding: 0 2.788vw;
            .playerName-playerLogo-playerGender-teamLogo-teamName {
              width: calc(100% - 2.43vw);
            }
            .color {
              width: 2.43vw;
              height: 1.38vw;
              border-width: 1px;
              border-style: solid;
            }
          }
          &.column3-playerInfor-position {
            .playerName-playerLogo-playerGender-teamLogo-teamName {
              width: calc(100% - 12vw);
            }
          }
        }
      }
    }
  }
}
.mixtmt_pc .combat_lineup_container:not(.none) {
  .combat_lineup {
    .publishBtn {
      &:hover {
        cursor: pointer;
        svg.publishBtn_icon {
          fill: var(--mixtmt_greyColor4);
        }
      }
    }
    .half_table_group {
      .table_title {
        .teamName {
          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
        .publishBtn {
          &:hover {
            cursor: pointer;
            svg.publishBtn_icon {
              fill: var(--mixtmt_greyColor4);
            }
          }
        }
      }
      .table_main {
        position: relative;
        width: 100%;
        height: auto;
        color: var(--mixtmt_greyColor3);
        &.home {
          &.isMax {
            &::before {
              content: '\20';
              position: absolute;
              top: 0;
              right: 0;
              z-index: 2;
              width: 1px;
              height: 100%;
              background-color: var(--mixtmt_greyColor7);
            }
          }
          .player_number {
            background-image: var(--mixtmt_homePlayerNo_bg);
          }
        }
        &.away {
          &.isMax {
            &::before {
              content: '\20';
              position: absolute;
              top: 0;
              left: 0;
              z-index: 2;
              width: 1px;
              height: 100%;
              background-color: var(--mixtmt_greyColor7);
            }
          }
          .player_number {
            background-image: var(--mixtmt_awayPlayerNo_bg);
          }
        }
        .customTable {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
        }

        .customTable_row {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          height: 5.55vw;
          padding: 0 0.694vw;
          border-bottom: 1px solid var(--mixtmt_greyColor7);
          .playerName-playerLogo-playerGender-teamLogo-teamName {
            .playerOther {
              .playerName {
                &:hover {
                  cursor: pointer;
                  color: var(--mixtmt_subColor1_1);
                  text-decoration: underline;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
